<template>
  <div>
    <DormList :dorms="dorms" v-if="dorms"/>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import DormList from '@/components/DormList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'UniversityGender',
  components: {
    DormList,
    FixedPopup
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.pageTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageDescription },
        { vmid: 'keywords', name: 'keywords', content: this.pageKeywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]       
    }
  },
  data () {
    return {
      url: '',
      dorms: null,
      errors: [],
      gender: '',
      typeID: null,
      popupDorms: null,
      details: null
    }
  },
  methods: {
    checkGender () {
      if (this.$route.params.type === 'erkek') {
        this.gender = 'Erkek'
        this.typeID = 1
      } else if (this.$route.params.type === 'kiz') {
        this.gender = 'Kız'
        this.typeID = 2
      }
    },
    getDorms () {
      this.checkGender()
      let self = this
      self.dorms = null
      axios.get(`/site/universities/dorms/${self.$route.params.slug}?dorm_type=${self.typeID}`)
        .then(response => {
          self.dorms = response.data.data.data
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['universityDetails']),
    pageTitle () {
      let title = ''
      if (this.universityDetails) {
        if (this.typeID === 1) title = this.universityDetails.male_title
        else if (this.typeID === 2) title = this.universityDetails.female_title
      }
      return title
    },
    pageDescription () {
      let title = ''
      if (this.universityDetails) {
        if (this.typeID === 1) title = this.universityDetails.male_description
        else if (this.typeID === 2) title = this.universityDetails.female_description
      }
      return title
    },
    pageKeywords () {
      let title = ''
      if (this.universityDetails) {
        if (this.typeID === 1) title = this.universityDetails.male_keywords
        else if (this.typeID === 2) title = this.universityDetails.female_keywords
      }
      return title
    }
  },
  created () {
    this.getDorms()
    this.url = window.location.origin + this.$route.fullPath //  '/' + this.$route.params.slug + '-yakin-ogrenci-yurtlari/'
  },
  watch: {
    $route () {
      this.checkGender()
      this.getDorms()
    }
  }
}
</script>

<style scoped>

</style>
